// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.posterWipe {
  position: relative;
  width: 100%;
  /* Room for the handle sitting on the bottom edge. */
  padding-bottom: 0.85rem;
}

.posterWipeFrame {
  position: relative;
  aspect-ratio: 2 / 3;
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  background-color: var(--white);
  border: 3px solid var(--white);
  box-shadow: 0 6px 18px rgba(14, 36, 99, 0.25);
  user-select: none;
  touch-action: none;
}

.posterWipeSketch,
.posterWipePoster {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
  user-select: none;
}

.posterWipePoster {
  background-color: var(--white);
}

.posterWipeRule {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 3px;
  background: var(--white);
  box-shadow: 0 0 0 1px rgba(14, 36, 99, 0.28);
  transform: translateX(-50%);
  pointer-events: none;
  z-index: 1;
}

.posterWipeHit {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 2.4rem;
  transform: translateX(-50%);
  cursor: ew-resize;
  touch-action: none;
  z-index: 2;
}

.posterWipeHandle {
  position: absolute;
  bottom: 0;
  width: 1.45rem;
  height: 1.45rem;
  border-radius: 50%;
  background: var(--white);
  border: 3px solid var(--navy);
  box-shadow: var(--shadow-card);
  transform: translateX(-50%);
  cursor: ew-resize;
  touch-action: none;
  z-index: 3;
}

.posterWipeHandle:focus-visible {
  outline: 3px solid var(--blue);
  outline-offset: 2px;
}

.posterWipe.dragging,
.posterWipe.dragging .posterWipeHandle,
.posterWipe.dragging .posterWipeHit {
  cursor: grabbing;
}

@media (prefers-reduced-motion: reduce) {
  .posterWipeHandle {
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/browser/webapp/components/gallery/poster-wipe.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,oDAAoD;EACpD,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,8BAA8B;EAC9B,6CAA6C;EAC7C,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,wBAAwB;EACxB,4CAA4C;EAC5C,2BAA2B;EAC3B,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,aAAa;EACb,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,wBAAwB;EACxB,6BAA6B;EAC7B,8BAA8B;EAC9B,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".posterWipe {\n  position: relative;\n  width: 100%;\n  /* Room for the handle sitting on the bottom edge. */\n  padding-bottom: 0.85rem;\n}\n\n.posterWipeFrame {\n  position: relative;\n  aspect-ratio: 2 / 3;\n  width: 100%;\n  border-radius: 12px;\n  overflow: hidden;\n  background-color: var(--white);\n  border: 3px solid var(--white);\n  box-shadow: 0 6px 18px rgba(14, 36, 99, 0.25);\n  user-select: none;\n  touch-action: none;\n}\n\n.posterWipeSketch,\n.posterWipePoster {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  pointer-events: none;\n  user-select: none;\n}\n\n.posterWipePoster {\n  background-color: var(--white);\n}\n\n.posterWipeRule {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 3px;\n  background: var(--white);\n  box-shadow: 0 0 0 1px rgba(14, 36, 99, 0.28);\n  transform: translateX(-50%);\n  pointer-events: none;\n  z-index: 1;\n}\n\n.posterWipeHit {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 2.4rem;\n  transform: translateX(-50%);\n  cursor: ew-resize;\n  touch-action: none;\n  z-index: 2;\n}\n\n.posterWipeHandle {\n  position: absolute;\n  bottom: 0;\n  width: 1.45rem;\n  height: 1.45rem;\n  border-radius: 50%;\n  background: var(--white);\n  border: 3px solid var(--navy);\n  box-shadow: var(--shadow-card);\n  transform: translateX(-50%);\n  cursor: ew-resize;\n  touch-action: none;\n  z-index: 3;\n}\n\n.posterWipeHandle:focus-visible {\n  outline: 3px solid var(--blue);\n  outline-offset: 2px;\n}\n\n.posterWipe.dragging,\n.posterWipe.dragging .posterWipeHandle,\n.posterWipe.dragging .posterWipeHit {\n  cursor: grabbing;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .posterWipeHandle {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
